module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00073-fs8.2ea5c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00073-fs8.png
// module id = 226
// module chunks = 0